var t=t=>t?.length==0;export{t as default};